import { createSlice } from '@reduxjs/toolkit'
import { fetchSymbols } from '../thunks/watchlist';

export const watchListSlice = createSlice({
    name: 'watchlist',
    initialState: {
        symbols: {},
        chartSymbols: [],
        chartLayoutType: 0, // 0,1,2,4
        isOneclick: false,
        isUserSigned: false
    },
    reducers: {
        setSymbolsData: (state, action) => {
            state.symbols = action.payload
        },
        addNewSymbol: (state, action) => {
            state.symbols[action.payload?.id] = action.payload;
        },
        updateSymbol: (state, action) => {
            if (state.symbols[action.payload?.id]) {
                state.symbols[action.payload?.id] = action.payload;
            }
        },
        deleteSymbol: (state, action) => {
            delete state.symbols[action.payload];
        },
        setIsOneClick: (state, action) => {
            state.isOneclick = action.payload || false
        },
        setIsUserSigned: (state, action) => {
            state.isUserSigned = action.payload || false
        },
        setChartLayoutType: (state, action) => {
            state.chartLayoutType = action.payload;
        },
        setChartSymbol: (state, action) => {
            const [index, symbol] = action.payload;
            state.chartSymbols[index] = symbol;
        },
        updateAmount: (state, action) => {
            if (state.symbols[action.payload?.id]) {
                state.symbols[action.payload?.id].amount = action.payload.amount;
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchSymbols.fulfilled, (state, action) => {
            state.symbols = action.payload;
        })
    }
})

// Action creators are generated for each case reducer function
export const { setSymbolsData, addNewSymbol, updateSymbol, deleteSymbol, setIsOneClick, updateAmount, setIsUserSigned, setChartLayoutType, setChartSymbol } = watchListSlice.actions

export default watchListSlice.reducer